<!-- eslint-disable @angular-eslint/template/no-call-expression -->
<div class="row mt-2 mb-2 overflow-x-auto">
  @if (facade.currentDerivativeType$ | async; as currentDerivativeType) {
    <div class="col-12">
      <div class="derivative-types mt-4">
        @for (derivativeType of facade.DERIVATIVE_TYPES; track $index) {
          <div
            class="no-select"
            [class.active]="currentDerivativeType === derivativeType"
            (click)="facade.toggleDerivativeType(derivativeType)"
          >
            {{ 'leverage-products.navigation.types.' + derivativeType | transloco }}
          </div>
        }
      </div>
      <div class="mt-4 mb-4">
        @switch (currentDerivativeType) {
          @case ('knockout') {
            <ng-container *ngTemplateOutlet="longShort" />
            <ng-container *ngTemplateOutlet="leverage" />
          }
          @case ('discount') {
            <ng-container *ngTemplateOutlet="cap" />
            <ng-container *ngTemplateOutlet="duration" />
          }
          @case ('optionsscheine') {
            <ng-container *ngTemplateOutlet="longShort" />
            <ng-container *ngTemplateOutlet="strike" />
            <ng-container *ngTemplateOutlet="duration" />
          }
          @case ('factor') {
            <div class="d-flex justify-content-between align-items-center">
              <ng-container *ngTemplateOutlet="longShort" />
              <ng-container *ngTemplateOutlet="quickMode" />
            </div>
            <ng-container *ngTemplateOutlet="factor" />
          }
        }
      </div>
    </div>
  }
</div>

<ng-template #cap>
  <div data-zid="cap" class="option-header mb-2">
    {{ 'leverage-products.navigation.options.cap.header' | transloco }}
  </div>
  @if (!isCustomCapSelected) {
    <div class="options">
      @for (cap of facade.CAPS; track $index) {
        <div
          [class.active]="cap.lower === (facade.currentCap$ | async)?.lower && cap.upper === (facade.currentCap$ | async)?.upper"
          (click)="applyCap(cap)"
        >
          {{ 'leverage-products.navigation.caps.' + cap.lower + '-' + cap.upper | transloco }}
        </div>
      }
      <div [class.active]="customCap?.lower || customCap?.upper" (click)="isCustomCapSelected = true">
        <svg class="icon icon-14">
          <use xlink:href="/assets/img/svgs/svgset.svg#edit" />
        </svg>
      </div>
    </div>
  } @else {
    <div class="d-flex align-items-center">
      <div class="leverage custom no-select mr-3">
        <input type="number" [(ngModel)]="customCap.lower" />
      </div>
      <div class="mr-3">{{ 'leverage-products.navigation.until' | transloco }}</div>
      <div class="leverage custom no-select mr-3">
        <input type="number" [(ngModel)]="customCap.upper" />
      </div>
      <div class="leverage no-select mr-3" (click)="applyCustomCap()">
        <svg class="icon icon-14">
          <use xlink:href="/assets/img/svgs/svgset.svg#tick" />
        </svg>
      </div>
      @if (facade.currentCap$ | async; as currentCap) {
        <div
          class="leverage no-select"
          (click)="isCustomCapSelected = false; applyCap(currentCap)"
          [title]="'leverage-products.custom-leverage.cancel' | transloco"
        >
          <svg class="icon icon-14">
            <use xlink:href="/assets/img/svgs/svgset.svg#close" />
          </svg>
        </div>
      }
    </div>
  }
</ng-template>

<ng-template #duration>
  <div data-zid="duration" class="option-header mt-4 mb-2">
    {{ 'leverage-products.navigation.options.duration.header' | transloco }}
  </div>
  @if (!isCustomDurationSelected) {
    <div class="options">
      @for (duration of facade.DURATIONS; track $index) {
        <div
          [class.active]="
            duration.lower === (facade.currentDuration$ | async)?.lower && duration.upper === (facade.currentDuration$ | async)?.upper
          "
          (click)="applyDuration(duration)"
        >
          {{ 'leverage-products.navigation.durations.' + duration.lower + '-' + duration.upper | transloco }}
        </div>
      }
      <div [class.active]="customDuration?.lower || customDuration?.upper" (click)="isCustomDurationSelected = true">
        <svg class="icon icon-14">
          <use xlink:href="/assets/img/svgs/svgset.svg#edit" />
        </svg>
      </div>
    </div>
  } @else {
    <div class="d-flex align-items-center">
      <div class="leverage custom no-select mr-3">
        <input type="number" [(ngModel)]="customDuration.lower" />
      </div>
      <div class="mr-3">{{ 'leverage-products.navigation.until' | transloco }}</div>
      <div class="leverage custom no-select mr-3">
        <input type="number" [(ngModel)]="customDuration.upper" />
      </div>
      <div class="leverage no-select mr-3" (click)="applyCustomDuration()">
        <svg class="icon icon-14">
          <use xlink:href="/assets/img/svgs/svgset.svg#tick" />
        </svg>
      </div>
      @if (facade.currentDuration$ | async; as currentDuration) {
        <div
          class="leverage no-select"
          (click)="isCustomDurationSelected = false; applyDuration(currentDuration)"
          [title]="'leverage-products.custom-leverage.cancel' | transloco"
        >
          <svg class="icon icon-14">
            <use xlink:href="/assets/img/svgs/svgset.svg#close" />
          </svg>
        </div>
      }
    </div>
  }
</ng-template>

<ng-template #strike>
  <div data-zid="strike" class="option-header mb-2">
    {{ 'leverage-products.navigation.options.strike.header' | transloco }}
  </div>
  @if (!isCustomStrikeSelected) {
    <div class="options">
      @for (strike of facade.STRIKES; track $index) {
        <div
          [class.active]="
            strike.lower === (facade.currentStrike$ | async)?.lower && strike.upper === (facade.currentStrike$ | async)?.upper
          "
          (click)="applyStrike(strike)"
        >
          {{ 'leverage-products.navigation.strikes.' + strike.lower + '-' + strike.upper | transloco }}
        </div>
      }
      <div [class.active]="customStrike?.lower || customStrike?.upper" (click)="isCustomStrikeSelected = true">
        <svg class="icon icon-14">
          <use xlink:href="/assets/img/svgs/svgset.svg#edit" />
        </svg>
      </div>
    </div>
  } @else {
    <div class="d-flex align-items-center">
      <div class="leverage custom no-select mr-3">
        <input type="number" [(ngModel)]="customStrike.lower" />
      </div>
      <div class="mr-3">{{ 'leverage-products.navigation.until' | transloco }}</div>
      <div class="leverage custom no-select mr-3">
        <input type="number" [(ngModel)]="customStrike.upper" />
      </div>
      <div class="leverage no-select mr-3" (click)="applyCustomStrike()">
        <svg class="icon icon-14">
          <use xlink:href="/assets/img/svgs/svgset.svg#tick" />
        </svg>
      </div>
      @if (facade.currentStrike$ | async; as currentStrike) {
        <div
          class="leverage no-select"
          (click)="isCustomStrikeSelected = false; applyStrike(currentStrike)"
          [title]="'leverage-products.custom-leverage.cancel' | transloco"
        >
          <svg class="icon icon-14">
            <use xlink:href="/assets/img/svgs/svgset.svg#close" />
          </svg>
        </div>
      }
    </div>
  }
</ng-template>

<ng-template #factor>
  <div data-zid="factor" class="option-header mb-2">{{ 'leverage-products.navigation.options.factor.header' | transloco }}</div>
  @if (!isCustomFactorSelected) {
    <div class="options">
      @for (factor of facade.FACTORS; track $index) {
        <div
          [class.active]="
            factor.lower === (facade.currentFactor$ | async)?.lower && factor.upper === (facade.currentFactor$ | async)?.upper
          "
          (click)="applyFactor(factor)"
        >
          {{ 'leverage-products.navigation.factors.' + factor.lower + '-' + factor.upper | transloco }}
        </div>
      }
      <div [class.active]="customFactor?.lower || customFactor?.upper" (click)="isCustomFactorSelected = true">
        <svg class="icon icon-14">
          <use xlink:href="/assets/img/svgs/svgset.svg#edit" />
        </svg>
      </div>
    </div>
  } @else {
    <div class="d-flex align-items-center">
      <div class="leverage custom no-select mr-3">
        <input type="number" [(ngModel)]="customFactor.lower" />
      </div>
      <div class="leverage no-select mr-3" [class.disabled]="!customFactor.lower" (click)="applyCustomFactor()">
        <svg class="icon icon-14" [class.text-color-success]="customFactor.lower">
          <use xlink:href="/assets/img/svgs/svgset.svg#tick" />
        </svg>
      </div>
      @if (facade.currentFactor$ | async; as currentFactor) {
        <div
          class="leverage no-select"
          (click)="isCustomFactorSelected = false; applyFactor(currentFactor)"
          [title]="'leverage-products.custom-leverage.cancel' | transloco"
        >
          <svg class="icon icon-14">
            <use xlink:href="/assets/img/svgs/svgset.svg#close" />
          </svg>
        </div>
      }
    </div>
  }
</ng-template>

<ng-template #leverage>
  @if (facade.currentLeverage$ | async; as currentLeverage) {
    <div data-zid="leverage" class="option-header mb-2">{{ 'leverage-products.navigation.options.leverage.header' | transloco }}</div>
    @if (!isCustomLeverageSelected) {
      <div class="options">
        @for (leverage of facade.LEVERAGES; track $index) {
          <div [class.active]="leverage === currentLeverage" (click)="applyLeverage(leverage)">{{ leverage }}x</div>
        }
        <div [class.active]="9999 === currentLeverage" (click)="applyLeverage(9999)">MAX</div>
        <div (click)="isCustomLeverageSelected = true">
          <svg class="icon icon-14">
            <use xlink:href="/assets/img/svgs/svgset.svg#edit" />
          </svg>
        </div>
      </div>
    } @else {
      <div class="d-flex">
        <div class="leverage custom no-select mr-3">
          <input
            #customLeverageInput
            type="number"
            [placeholder]="'leverage-products.custom-leverage.placeholder' | transloco: { value: facade.MAX_CUSTOM_LEVERAGE }"
            [ngModel]="facade.customLeverage"
            (keyup)="facade.changeCustomLeverage($event)"
            (keydown.enter)="useCustomLeverage()"
            min="2"
            [max]="facade.MAX_CUSTOM_LEVERAGE"
            zeroAutofocus
          />
        </div>
        <div
          class="leverage no-select mr-3"
          [title]="'leverage-products.custom-leverage.confirm' | transloco"
          [class.disabled]="!facade.isValidCustomLeverage()"
          (click)="useCustomLeverage()"
        >
          <svg class="icon icon-14" [class.text-color-success]="facade.isValidCustomLeverage()">
            <use xlink:href="/assets/img/svgs/svgset.svg#tick" />
          </svg>
        </div>
        <div
          class="leverage no-select"
          (click)="isCustomLeverageSelected = false"
          [title]="'leverage-products.custom-leverage.cancel' | transloco"
        >
          <svg class="icon icon-14">
            <use xlink:href="/assets/img/svgs/svgset.svg#close" />
          </svg>
        </div>
      </div>
    }
    <ng-template #customLeverage>
      <div class="d-flex">
        <div class="leverage custom no-select mr-3">
          <input
            #customLeverageInput
            type="number"
            [placeholder]="'leverage-products.custom-leverage.placeholder' | transloco: { value: facade.MAX_CUSTOM_LEVERAGE }"
            [ngModel]="facade.customLeverage"
            (keyup)="facade.changeCustomLeverage($event)"
            (keydown.enter)="useCustomLeverage()"
            min="2"
            [max]="facade.MAX_CUSTOM_LEVERAGE"
          />
        </div>
        <div
          class="leverage no-select mr-3"
          [title]="'leverage-products.custom-leverage.confirm' | transloco"
          [class.disabled]="!facade.isValidCustomLeverage()"
          (click)="useCustomLeverage()"
        >
          <svg class="icon icon-14" [class.text-color-success]="facade.isValidCustomLeverage()">
            <use xlink:href="/assets/img/svgs/svgset.svg#tick" />
          </svg>
        </div>
        <div
          class="leverage no-select"
          (click)="isCustomLeverageSelected = false"
          [title]="'leverage-products.custom-leverage.cancel' | transloco"
        >
          <svg class="icon icon-14">
            <use xlink:href="/assets/img/svgs/svgset.svg#close" />
          </svg>
        </div>
      </div>
    </ng-template>
  }
</ng-template>

<ng-template #quickMode>
  <div class="d-flex" data-zid="quickMode">
    <label class="checkbox text-nowrap">
      {{ 'leverage-products.navigation.options.quick-search.label' | transloco }}
      <input type="checkbox" [(ngModel)]="isQuickMode" (change)="facade.toggleQuickMode(isQuickMode)" />
      <span class="checkmark"></span>
    </label>

    <div class="ml-2">
      <span data-zid="info-icon" (click)="modal.open(modalContent, { size: 'sm' })">
        <svg class="icon icon-18 cursor-pointer">
          <use xlink:href="/assets/img/svgs/svgset.svg#info" />
        </svg>
      </span>
      <ng-template #modalContent let-modal>
        <web-design-system-modal
          [headline]="'leverage-products.navigation.options.quick-search.modal.header' | transloco"
          (dismiss)="modal.dismiss('Cross click')"
        >
          <p>{{ 'leverage-products.navigation.options.quick-search.modal.body' | transloco }}</p>
        </web-design-system-modal>
      </ng-template>
    </div>
  </div>
</ng-template>

<ng-template #longShort>
  @if (facade.productType$ | async; as productType) {
    <div class="nav-tabs mb-4 no-select" data-zid="longShort">
      <ng-container *ngTemplateOutlet="longShortTab; context: { type: LeverageProductType.CALL }" />
      <ng-container *ngTemplateOutlet="longShortTab; context: { type: LeverageProductType.PUT }" />
    </div>
    <ng-template #longShortTab let-type="type">
      <div class="nav-item">
        <a class="nav-link text-nowrap font-medium" [class.active]="productType === type" (click)="facade.toggleLeverageType(type)">
          {{ type === LeverageProductType.PUT ? 'Short' : 'Long ' }}
        </a>
      </div>
    </ng-template>
  }
</ng-template>
